// STOP READING OUR CODE, BITCH.
document.addEventListener('DOMContentLoaded', function() {
  const terminalWindow = document.getElementById('terminal-window');
  const isDesktop = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  // Set terminal style based on user agent
  terminalWindow.classList.add(isDesktop ? 'dos' : 'mac');

  // Screen elements
  const homeScreen = document.getElementById('home-screen');
  const manifestoScreen = document.getElementById('manifesto-screen');
  let typingTimeout = null;

  // Function to show a specific screen
  function showScreen(screen) {
    [homeScreen, manifestoScreen].forEach(s => s.classList.add('hidden'));

    // Clear any existing typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
      typingTimeout = null;
    }

    if (screen === manifestoScreen) {
      hideManifestoContinue();
      const manifestoText = document.getElementById('manifesto-source').textContent;
      typeText(document.getElementById('manifesto'), manifestoText, showManifestoContinue);
    }
    screen.classList.remove('hidden');
  }

  function showSignupScreen() {
      document.getElementsByClassName('klaviyo-form-VXTjsa')[0].style.display = '';
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VXTjsa']);
  }

  // Function to type text character by character
  function typeText(element, text, callback) {
    let index = 0;
    element.textContent = '';
    
    function type() {
      if (index < text.length) {
        element.textContent += text[index];
        index++;
        typingTimeout = setTimeout(type, 20);
      } else if (callback) {
        callback();
      }
    }
    type();
  }

  function hideManifestoContinue() {
    const continueElement = document.querySelector('.clickable[data-next-screen="home-screen"]');
    continueElement.classList.add('hidden');
  }

  function showManifestoContinue() {
    const continueElement = document.querySelector('.clickable[data-next-screen="home-screen"]');
    continueElement.classList.remove('hidden');
  }

  function initPasswordScreen() {
    showEl('password-screen');

    // Add click handlers for all clickable elements
    document.querySelectorAll('.clickable').forEach(element => {
      element.addEventListener('click', function() {
        const nextScreen = this.getAttribute('data-next-screen');
        if (nextScreen) {
          if (nextScreen === 'signup-screen') {
            showSignupScreen();
          }
          else {
            const targetScreen = document.getElementById(nextScreen);
            if (targetScreen) {
              showScreen(targetScreen);
            }
          }
        }
      });
    });

    // Manifesto screen navigation
    manifestoScreen.addEventListener('click', () => showScreen(homeScreen));

  //   document.addEventListener('keydown', function(e) {
  //     e.preventDefault();

  //     if (!homeScreen.classList.contains('hidden')) {
  //       if (e.key === '1') {
  //         showScreen(manifestoScreen);
  //       } else if (e.key === '2') {
  //         showSignupScreen();
  //       }
  //     }
  //     else if (!manifestoScreen.classList.contains('hidden')) {
  //       showScreen(homeScreen);
  //     }
  //   });

    document.addEventListener('keydown', function(e) {
      if (e.target.tagName === 'INPUT' || 
          e.target.tagName === 'TEXTAREA' || 
          e.target.tagName === 'SELECT' ||
          e.target.isContentEditable) {
        return;
      }

      if (!homeScreen.classList.contains('hidden')) {
        if (e.key === '1') {
          e.preventDefault();
          showScreen(manifestoScreen);
        } else if (e.key === '2') {
          e.preventDefault();
          showSignupScreen();
        }
      }
      else if (!manifestoScreen.classList.contains('hidden')) {
        e.preventDefault();
        showScreen(homeScreen);
      }
    });
  }
  
  const KLAVIYO_WINNERS_FORM_ID = 'VJLfvt';
  if (window.location.hostname === 'winners.fakeintel.com') {
    showWinners();
  } else if (window.location.hostname === 'losers.fakeintel.com' || window.location.hostname === 'invite.fakeintel.com') {
    showLosers();
  } else {
    initPasswordScreen();
  }
  
  function rmEl(elId) {
    const el = document.getElementById(elId);
    el && el.parentNode.removeChild(el);
  }

  function showEl(elId) {
    document.getElementById(elId).style.display = '';
  }

  function showWinners() {
    showEl('winners');
    rmEl('losers');
    document.getElementsByClassName('klaviyo-form-'+KLAVIYO_WINNERS_FORM_ID)[0].style.display = '';
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', KLAVIYO_WINNERS_FORM_ID]);
  }

  function showLosers() {
    showEl('losers');
    rmEl('winners');
    rmEl('password-screen');
  }

  window.addEventListener('klaviyoForms', e => {
    if (e.detail.type=='close' && e.detail.formId == KLAVIYO_WINNERS_FORM_ID) {
      showEl('winners-success');
    }
  });


  // Auto-click newsletter signup on page load
  const signupElement = document.querySelector('.clickable[data-next-screen="signup-screen"]'); 
  if (signupElement) {
    setTimeout(function() {
      signupElement.click();
    }, 100);
  }
});
